// extracted by mini-css-extract-plugin
export default {"root":"PieChart_root__+1XO0","chart":"PieChart_chart__qu0BQ","title":"PieChart_title__SOYre","note":"PieChart_note__UEmdN","chartScroll":"PieChart_chartScroll__+7FRb"};